import React, { Fragment } from "react"
import { useParams } from "react-router-dom"
import AnonymousFeedback from '../components/AnonymousFeedback'
import IndentifiedFeedback from '../components/IndentifiedFeedback'
import { Container } from 'react-bootstrap'
import NavbarComp from '../components/NavbarComp'
import FooterComp from '../components/FooterComp'
import { useSelector } from 'react-redux'

function TermsAndConditions() {
  const { register } = useParams();
  const auth = useSelector((state) => state.auth);
  return <Fragment>
    <NavbarComp />
    <div className="page-sections">
      <div className='terms-and-conditions-wrap'>
        <Container>
          <div className='terms-and-conditions-contents'>
            <h2 className='main-title-style'>Terms and Conditions</h2>
            {auth.user !== null || register == 1 ?
              <IndentifiedFeedback /> :
              <AnonymousFeedback />}
          </div>
        </Container>
      </div>
    </div>
    <FooterComp />
  </Fragment>;
}

export default TermsAndConditions;